import { Component } from '@angular/core';
import { LoaderService } from './loader.service';
@Component({
  selector: 'app-loader-chargebee',
  templateUrl: './loader-chargebee.component.html',
  styleUrls: ['./loader-chargebee.component.scss'],
})

export class LoaderChargebeeComponent {
  isLoading$ = this.loaderService.loading$;

  constructor(private loaderService: LoaderService) {}
}
